import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ElementOriginChange = ProjectChangeMap[ProjectChangeType.ElementOrigin];

/**
 * Re-point a CSV-import element's {@link IElement.origin}. Used by "Save mapping"
 * to flip an inline (unsaved) mapping snapshot to a `stored` reference once the
 * mapping is written to the resource-code table. No-op on a version root.
 *
 * @param element - Current element state
 * @param change - Replacement {@link ElementOrigin}
 * @returns Partial patch or undefined for a version root
 */
export const elementOriginToChange = (
  element: OneOfElements,
  change: ElementOriginChange,
): Partial<OneOfElements> | undefined => {
  if (projectGuards.is.buildingVersion(element)) return undefined;

  return { origin: change.origin };
};
